(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('TestServiceController', TestServiceController);

    TestServiceController.$inject = ['$timeout', '$scope', '$stateParams', 'TestServices', 'Company', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', '$injector', 'CompanyCustom', '$window', 'DateUtils','MarketingCampaignCustom','CompanyCustomerCustom'];

    function TestServiceController($timeout, $scope, $stateParams, TestServices, Company, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, $injector, CompanyCustom, $window, DateUtils,MarketingCampaignCustom,CompanyCustomerCustom) {


        var vm = this;
        vm.branchlist = '{"list":[{"branchtitle":"ش1","branchurl":"x1","user":"u1","baseurl":"x0"},' +
            '{"branchtitle":"a2","branchurl":"x2","user":"u2","baseurl":"x0"}]}'

        vm.getCompanyInfoByKeyURL = getCompanyInfoByKeyURL;
        vm.getRootCategoriesByKeyURL = getRootCategoriesByKeyURL;
        vm.getCategoriesByParentId = getCategoriesByParentId;
        vm.getServiceItemByCategoryId = getServiceItemByCategoryId;
        vm.getCategoryById = getCategoryById;
        vm.getServiceItemById = getServiceItemById;
        vm.getServiceTimeSessionFromToDate = getServiceTimeSessionFromToDate;
        vm.getServiceTimeSessionTimesInOneDate = getServiceTimeSessionTimesInOneDate;
        vm.getPriceInfoDtailByServiceItemFromTimeSession = getPriceInfoDtailByServiceItemFromTimeSession;
        vm.getServiceOptionItemsByServiceItemId = getServiceOptionItemsByServiceItemId;
        vm.getServiceTimeSessionById = getServiceTimeSessionById;
        vm.getImageDataById = getImageDataById;
        vm.saveOrderBagVM = saveOrderBagVM;
        vm.testReminder = testReminder;
        vm.getImageDataVMByAlbumId = getImageDataVMByAlbumId;
        vm.sendTestSMS = sendTestSMS;
        vm.sendTestEmail = sendTestEmail;
        vm.generateTimeSessionsForAllServices = generateTimeSessionsForAllServices;
        vm.testSubscriptionNearToExpire = testSubscriptionNearToExpire;
        vm.testUpdateExpireCompanyStatus = testUpdateExpireCompanyStatus;
        vm.insertNewConversation = insertNewConversation;
        vm.insertNewMessage = insertNewMessage;
        vm.cancelAllExpireTwoStepReserve = cancelAllExpireTwoStepReserve;
        vm.exportOrderBagToExcel = exportOrderBagToExcel;
        vm.getServiceAvailableDatesInNextDays = getServiceAvailableDatesInNextDays;
        vm.getServiceAvailableTimesInOneDate = getServiceAvailableTimesInOneDate;
        vm.getCustomerByMobileNumber = getCustomerByMobileNumber;
        vm.addTaminBranch = addTaminBranch;
        vm.generateTimeSessionsForAllServicesJustOnDate = generateTimeSessionsForAllServicesJustOnDate;
        vm.addmultiplebranch = addmultiplebranch;
        vm.addLocationList = addLocationList;
        vm.generateTimeSessionsForAllServicesJustOnDateOneCompany = generateTimeSessionsForAllServicesJustOnDateOneCompany;
        vm.sendTestCustomerSatisfactionSMS = sendTestCustomerSatisfactionSMS;
        vm.fromDateForGenerate = "2018-09-25";
        vm.addDaysToSubscriptionByCompany = addDaysToSubscriptionByCompany;
        vm.companyKeyUrl = "";
        vm.category = "";
        vm.daysToAdd = 0;
        vm.getCompaniesSubscriptionNearToExpire = getCompaniesSubscriptionNearToExpire;
        vm.addFreeSMSPackage = addFreeSMSPackage;

        vm.addCustomSMSPackage = addCustomSMSPackage;
        vm.smsPackages = SubscriptionPackageCustom.getSubscriptionPackageByPTypeAndSType('SMS', 'CUSTOM_1').query();
        vm.sendTestCustomerFirstReminderSMS = sendTestCustomerFirstReminderSMS;
        vm.getTopNCompanyManager = getTopNCompanyManager;
        vm.testToast = testToast;
        vm.getServantByMarketPlaceFilter = getServantByMarketPlaceFilter;

        vm.addDaysToSubscriptionByCompaniesCategory = addDaysToSubscriptionByCompaniesCategory;
        vm.setFeatureByCompanySubscriptionId = setFeatureByCompanySubscriptionId;
        vm.sendTestReservationConfirmedInfoMsg = sendTestReservationConfirmedInfoMsg;
        vm.getToken = getToken;
        vm.createUserAccessForServantByPhoneNumber = createUserAccessForServantByPhoneNumber;
        vm.getReserveListByCustomer = getReserveListByCustomer;
        vm.batchCompanyCustomer = [];
        vm.addBatchCompanyCustomer = addBatchCompanyCustomer;
        vm.testIcal = testIcal;
        vm.sendVerificationTestSMS = sendVerificationTestSMS;
        vm.sendRebookNotification = sendRebookNotification;
        vm.sendRebookSMS = sendRebookSMS;
        vm.addSampleGtag = addSampleGtag;
        vm.sendTestCustomerSecondReminderSMS = sendTestCustomerSecondReminderSMS;
        vm.sendTestSMSPackageGoingToFinish = sendTestSMSPackageGoingToFinish;
        vm.sendTestSMSPackageFinished = sendTestSMSPackageFinished;
        vm.sendTestSubscriptionNearToExpireNotification = sendTestSubscriptionNearToExpireNotification;
        vm.sendTestSubscriptionIsExpiredNotification = sendTestSubscriptionIsExpiredNotification;
        vm.sendTestAutomaticSubscriptionNearToExpireNotification = sendTestAutomaticSubscriptionNearToExpireNotification;
        vm.sendTestAutomaticApproveReserveRequest = sendTestAutomaticApproveReserveRequest;
        vm.sendAllSatisfactionNotification = sendAllSatisfactionNotification;
        vm.deActiveCompany = deActiveCompany;
        vm.sendTestSupplierFirstJourneyNotification = sendTestSupplierFirstJourneyNotification;
        vm.selectItems = null;
        vm.invoiceReport = invoiceReport;

        vm.batchInvoiceInfo = [];
        vm.addBatchInvoiceInfo = addBatchInvoiceInfo;
        vm.sendAutomaticMarketingCampaign = sendAutomaticMarketingCampaign;
        vm.testCalculateCommission = testCalculateCommission;

        vm.testTehranTime = testTehranTime;
        vm.testSmsNearFinish = testSmsNearFinish;
        vm.marketingCampaignId = null;
        vm.sendMarketingCampaign = sendMarketingCampaign;
        vm.sendMarketingCampaignLoading = false;
        vm.companyCustomerIds = null;
        vm.mergeCompanyCustomers=mergeCompanyCustomers;
        vm.phoneNumber = '';
        vm.removePhoneNumber = removePhoneNumber;
        vm.removePhoneNumberLoading = false;

        initSelectItems();

        function initSelectItems() {
            vm.selectItems = [];
            var item1 = {};
            item1.id = 1;
            item1.name = "name1";
            vm.selectItems.push(item1);

            var item2 = {};
            item2.id = 2;
            item2.name = "name2";
            vm.selectItems.push(item2);

            var item3 = {};
            item3.id = 3;
            item3.name = "name3";
            vm.selectItems.push(item3);

            var item4 = {};
            item4.id = 4;
            item4.name = "name4";
            vm.selectItems.push(item4);


        }

        function testToast() {

            var mdToast = $injector.get('$mdToast');

            var type = 'success';

            mdToast.show(
                mdToast.simple()
                    .content('تست می شود')
                    .hideDelay(600000)
                    .theme(type + '-toast'));

        }

        function exportOrderBagToExcel() {
            var serviceItemid = prompt("Enter ServiceId", "0");

            if (serviceItemid == null || serviceItemid == "") {

            } else {

            }
        }

        function generateTimeSessionsForAllServices() {


            var untilDate = vm.fromDateForGenerate;
            //prompt("Enter the Until Date", "2018-09-25");

            if (untilDate == null || untilDate == "") {

            } else {
                vm.company = TestServices.generateTimeSessionsForAllServices(untilDate).query();
            }

        }

        function generateTimeSessionsForAllServicesJustOnDate() {

            var untilDate = prompt("Enter the On Date", "2018-07-10");

            if (untilDate == null || untilDate == "") {

            } else {
                vm.company = TestServices.generateTimeSessionsForAllServicesJustOnDate(untilDate).query();
            }

        }

        function generateTimeSessionsForAllServicesJustOnDateOneCompany() {

            var untilDate = prompt("Enter the On Date", "2018-07-10");
            var url = prompt("Enter the company url", "");

            if (untilDate == null || untilDate == "") {

            } else {
                vm.company = TestServices.generateTimeSessionsForAllServicesJustOnDateOneCompany(untilDate, url).query();
            }

        }

        vm.finalApproveOrderBagById = finalApproveOrderBagById;

        function getCompanyInfoByKeyURL() {
            vm.company = TestServices.getCompanyInfoByKeyURL("parandeh.reserweb.com").query();

        }

        function getRootCategoriesByKeyURL() {
            vm.serviceCategories = TestServices.getRootCategoriesByKeyURL("min.tikon.com").query();
        }

        function getCategoriesByParentId() {
            vm.serviceCategories = TestServices.getCategoriesByParentId('1583').query();
        }

        function getServiceItemByCategoryId() {
            vm.serviceItems = TestServices.getServiceItemByCategoryId('6518').query();
        }

        function getCategoryById() {
            vm.serviceCategory = TestServices.getCategoryById('1579').query();
        }

        function getServiceItemById() {
            vm.serviceItem = TestServices.getServiceItemById('1427').query();
        }

        function getServiceTimeSessionFromToDate() {
            var startDate = new Date(Date.UTC(2016, 10, 10, 10, 20, 20));
            var endDate = new Date(Date.UTC(2016, 12, 8, 10, 30, 30));
            vm.serviceTimeSessions = TestServices.getServiceTimeSessionFromToDate('1167', startDate.toISOString(), endDate.toISOString()).query();
        }

        function getServiceTimeSessionTimesInOneDate() {
            var dateTime = new Date(Date.UTC(2016, 10, 10, 10, 20, 20));
            vm.serviceTimeSessionTimes = TestServices.getServiceTimeSessionTimesInOneDate('1167', dateTime.toISOString()).query();
        }

        function getPriceInfoDtailByServiceItemFromTimeSession() {
            vm.priceInfoDtails = TestServices.getPriceInfoDtailByServiceItemFromTimeSession('1427', '1651').query();
        }

        function getServiceOptionItemsByServiceItemId() {
            vm.serviceItemOptions = TestServices.getServiceOptionItemsByServiceItemId('1427').query();
        }

        function getServiceTimeSessionById() {
            vm.serviceTimeSession = TestServices.getServiceTimeSessionById('1648').query();
        }

        function getImageDataById() {
            vm.imageData = TestServices.getImageDataById('3843').query();
        }

        function saveOrderBagVM() {

            vm.orderBagVM = {
                "customerId": 1405,
                "orderBagServiceItems": [
                    /* {
                         "serviceItemId":1427,
                         "serviceItem": {
                             "id": 9552,
                             "itemTitle": "عمل بینی",
                             "description": "بینی شمارا عمل میکنیم",
                             "minPreReserveTime": null,
                             "maxPreReserveTime": null,
                             "hasWaitingList": null,
                             "mustGetParticipantInfo": null,
                             "canBeCanceled": null,
                             "minPreCancelTime": null,
                             "paymentType": null,
                             "serviceType": "INDEPENDENT_SERVICE",
                             "options": [
                                 {
                                     "id": 32513,
                                     "title": "ServiceOption"
                                 },
                                 {
                                     "id": 32509,
                                     "title": "ServiceOption"
                                 }
                             ],
                             "discountInfoId": 9549,
                             "locationId": null,
                             "imageAlbumId": 30860,
                             "capacityInfoId": 9554,
                             "categoryId": 2616,
                             "priceinfoId": null,
                             "serviceTimes": [
                                 {
                                     "id": 9939,
                                     "formState": "BASIC_SCHEDULE_INFO",
                                     "scheduleType": "PRIMARY",
                                     "timingInfo": null,
                                     "weeklyScheduleInfoId": 9933,
                                     "weeklyScheduleInfo": {
                                         "id": 9933,
                                         "datePeriods": [
                                             {
                                                 "id": 9930,
                                                 "fromDate": "2016-09-28",
                                                 "toDate": "2016-11-23",
                                                 "offdays": [
                                                     {
                                                         "id": 9929,
                                                         "offDate": "2016-11-21",
                                                         "offDayType": null
                                                     }
                                                 ]
                                             }
                                         ],
                                         "dailyDurations": [
                                             {
                                                 "id": 9931,
                                                 "startTime": "1970-01-01T04:30:00.000Z",
                                                 "endTime": "1970-01-01T13:30:00.000Z",
                                                 "duration": 20,
                                                 "gaptime": 15,
                                                 "offtimes": [
                                                     {
                                                         "id": 9932,
                                                         "i": null,
                                                         "fromTime": "1970-01-01T08:30:00.000Z",
                                                         "toTime": "1970-01-01T09:30:00.000Z",
                                                         "offTimeType": null
                                                     }
                                                 ]
                                             }
                                         ],
                                         "weekdays": [
                                             {
                                                 "id": 9934,
                                                 "weekday": "SATURDAY"
                                             },
                                             {
                                                 "id": 9936,
                                                 "weekday": "TUESDAY"
                                             },
                                             {
                                                 "id": 9938,
                                                 "weekday": "MONDAY"
                                             },
                                             {
                                                 "id": 9937,
                                                 "weekday": "WEDNESDAY"
                                             },
                                             {
                                                 "id": 9935,
                                                 "weekday": "SUNDAY"
                                             }
                                         ],
                                         "datePeriod": {
                                             "id": 9930,
                                             "fromDate": "2016-09-28",
                                             "toDate": "2016-11-23",
                                             "offdays": [
                                                 {
                                                     "id": 9929,
                                                     "offDate": "2016-11-21",
                                                     "offDayType": null
                                                 }
                                             ]
                                         },
                                         "timePeriod": {
                                             "id": 9931,
                                             "startTime": "1970-01-01T04:30:00.000Z",
                                             "endTime": "1970-01-01T13:30:00.000Z",
                                             "duration": 20,
                                             "gaptime": 15,
                                             "offtimes": [
                                                 {
                                                     "id": 9932,
                                                     "i": null,
                                                     "fromTime": "1970-01-01T08:30:00.000Z",
                                                     "toTime": "1970-01-01T09:30:00.000Z",
                                                     "offTimeType": null
                                                 }
                                             ]
                                         }
                                     },
                                     "serviceItemId": 9552,
                                     "discountAmount": 15
                                 },
                                 {
                                     "id": 9548,
                                     "formState": "BASIC_SCHEDULE_INFO",
                                     "scheduleType": "PRIMARY",
                                     "timingInfo": null,
                                     "weeklyScheduleInfoId": 9541,
                                     "weeklyScheduleInfo": {
                                         "id": 9541,
                                         "datePeriods": [
                                             {
                                                 "id": 9539,
                                                 "fromDate": "2016-12-21",
                                                 "toDate": "2017-03-20",
                                                 "offdays": []
                                             }
                                         ],
                                         "dailyDurations": [
                                             {
                                                 "id": 9540,
                                                 "startTime": "1970-01-01T04:30:00.000Z",
                                                 "endTime": "1970-01-01T14:30:00.000Z",
                                                 "duration": 90,
                                                 "gaptime": 60,
                                                 "offtimes": []
                                             }
                                         ],
                                         "weekdays": [
                                             {
                                                 "id": 9545,
                                                 "weekday": "SATURDAY"
                                             },
                                             {
                                                 "id": 9542,
                                                 "weekday": "MONDAY"
                                             },
                                             {
                                                 "id": 9546,
                                                 "weekday": "TUESDAY"
                                             },
                                             {
                                                 "id": 9543,
                                                 "weekday": "WEDNESDAY"
                                             },
                                             {
                                                 "id": 9544,
                                                 "weekday": "SUNDAY"
                                             },
                                             {
                                                 "id": 9547,
                                                 "weekday": "THURSDAY"
                                             }
                                         ],
                                         "datePeriod": {
                                             "id": 9539,
                                             "fromDate": "2016-12-21",
                                             "toDate": "2017-03-20",
                                             "offdays": []
                                         },
                                         "timePeriod": {
                                             "id": 9540,
                                             "startTime": "1970-01-01T04:30:00.000Z",
                                             "endTime": "1970-01-01T14:30:00.000Z",
                                             "duration": 90,
                                             "gaptime": 60,
                                             "offtimes": []
                                         }
                                     },
                                     "serviceItemId": 9552,
                                     "discountAmount": 10
                                 },
                                 {
                                     "id": 10748,
                                     "formState": "BASIC_SCHEDULE_INFO",
                                     "scheduleType": "PRIMARY",
                                     "timingInfo": null,
                                     "weeklyScheduleInfoId": 10747,
                                     "weeklyScheduleInfo": {
                                         "id": 10747,
                                         "datePeriods": [
                                             {
                                                 "id": 10745,
                                                 "fromDate": "2014-04-20",
                                                 "toDate": "2014-05-22",
                                                 "offdays": []
                                             }
                                         ],
                                         "dailyDurations": [
                                             {
                                                 "id": 10746,
                                                 "startTime": "1970-01-01T04:30:00.000Z",
                                                 "endTime": "1970-01-01T13:30:00.000Z",
                                                 "duration": 90,
                                                 "gaptime": 15,
                                                 "offtimes": []
                                             }
                                         ],
                                         "weekdays": [
                                             {
                                                 "id": 10752,
                                                 "weekday": "SATURDAY"
                                             },
                                             {
                                                 "id": 10754,
                                                 "weekday": "MONDAY"
                                             },
                                             {
                                                 "id": 10751,
                                                 "weekday": "TUESDAY"
                                             },
                                             {
                                                 "id": 10755,
                                                 "weekday": "WEDNESDAY"
                                             },
                                             {
                                                 "id": 10750,
                                                 "weekday": "SUNDAY"
                                             },
                                             {
                                                 "id": 10753,
                                                 "weekday": "THURSDAY"
                                             }
                                         ],
                                         "datePeriod": {
                                             "id": 10745,
                                             "fromDate": "2014-04-20",
                                             "toDate": "2014-05-22",
                                             "offdays": []
                                         },
                                         "timePeriod": {
                                             "id": 10746,
                                             "startTime": "1970-01-01T04:30:00.000Z",
                                             "endTime": "1970-01-01T13:30:00.000Z",
                                             "duration": 90,
                                             "gaptime": 15,
                                             "offtimes": []
                                         }
                                     },
                                     "serviceItemId": 9552,
                                     "discountAmount": 5
                                 }
                             ],
                             "scheduleInfo": {
                                 "id": null,
                                 "formState": null,
                                 "scheduleType": null,
                                 "timingInfo": null,
                                 "weeklyScheduleInfoId": null,
                                 "weeklyScheduleInfo": {
                                     "id": null,
                                     "datePeriods": [],
                                     "dailyDurations": [],
                                     "weekdays": [],
                                     "datePeriod": {
                                         "id": null,
                                         "fromDate": null,
                                         "toDate": null,
                                         "offdays": []
                                     },
                                     "timePeriod": {
                                         "id": null,
                                         "startTime": null,
                                         "endTime": null,
                                         "duration": null,
                                         "gaptime": null,
                                         "offtimes": []
                                     }
                                 },
                                 "serviceItemId": null,
                                 "discountAmount": null
                             },
                             "servants": [],
                             "agreementId": 9553,
                             "startDate": null,
                             "endDate": null,
                             "servicePriceInfo": [],
                             "servicePriceInfoDtail": {
                                 "id": null,
                                 "title": null,
                                 "capacityRatio": null,
                                 "price": null,
                                 "coworkerPrice": null,
                                 "priceInfoId": null,
                                 "priceInfo": null,
                                 "discount": null,
                                 "priceWithDiscount": null
                             },
                             "serviceOptionItem": {
                                 "id": null,
                                 "optionName": null,
                                 "description": null,
                                 "optionInfoId": null,
                                 "priceInfoId": null,
                                 "imagesId": null,
                                 "priceInfoDtail": null,
                                 "selected": false,
                                 "optionInfo": null
                             },
                             "capacityInfo": {
                                 "id": null,
                                 "qty": null
                             },
                             "agreement": {
                                 "id": 9553,
                                 "rules": "",
                                 "agreement": ""
                             },
                             "coverImage": null,
                             "minPrice": null,
                             "maxDiscount": null,
                             "imageAlbum": {
                                 "id": 30860,
                                 "isSingleImage": null,
                                 "caption": null,
                                 "imageList": [
                                     {
                                         "id": 32517,
                                         "fileName": null,
                                         "caption": "caption",
                                         "fileType": null,
                                         "fileDataContentType": "image/jpeg",
                                         "thumbnailData": null,
                                         "thumbnailDataContentType": null,
                                         "isCoverImage": true,
                                         "albumInfoId": 30860
                                     },
                                     {
                                         "id": 32518,
                                         "fileName": null,
                                         "caption": "caption",
                                         "fileType": null,
                                         "fileDataContentType": "image/jpeg",
                                         "thumbnailData": null,
                                         "thumbnailDataContentType": null,
                                         "isCoverImage": true,
                                         "albumInfoId": 30860
                                     }
                                 ]
                             },
                             "tags": []
                         },
                         "orderBagServiceItemDtail": [
                             {
                                 "id": null,
                                 "title": "بزرگسال",
                                 "capacityRatio": null,
                                 "price": 50000,
                                 "coworkerPrice": null,
                                 "priceInfoDtailId": 1498,
                                 "priceInfo": {
                                     "id": 1497,
                                     "fromValidDate": "2016-11-20T20:30:00.000Z",
                                     "priceType": "FIXED",
                                     "servants": []
                                 },
                                 "discount": 10,
                                 "priceWithDiscount": 45000,
                                 "gty": 1,


                             },
                             {
                                 "id": null,
                                 "title": "کودک",
                                 "capacityRatio": null,
                                 "price": 20000,
                                 "coworkerPrice": null,
                                 "priceInfoDtailId": 1502,
                                 "priceInfo": {
                                     "id": 1501,
                                     "fromValidDate": "2016-09-21T20:30:00.000Z",
                                     "priceType": "FIXED",
                                     "servants": []
                                 },
                                 "discount": 10,
                                 "priceWithDiscount": 18000,
                                 "gty": 2,

                             }
                         ],
                         "options": [
                             {
                                 "id": 1492,
                                 "optionName": "کاشت ابرو",
                                 "description": "ابرو هم میکاریم",
                                 "optionInfoId": 1491,
                                 "priceInfoId": 1497,
                                 "imagesId": null,
                                 "priceInfoDtail": {
                                     "id": 1498,
                                     "title": "ابرو!",
                                     "capacityRatio": null,
                                     "price": 200000,
                                     "coworkerPrice": null,
                                     "priceInfoId": 1497,
                                     "priceInfo": {
                                         "id": 1497,
                                         "fromValidDate": "2016-12-20T20:30:00.000Z",
                                         "priceType": null,
                                         "servants": []
                                     },
                                     "discount": null,
                                     "priceWithDiscount": 150000
                                 },
                                 "selected": true,
                                 "optionInfo": {
                                     "id": 1491,
                                     "title": "ServiceOption"
                                 }
                             },
                             {
                                 "id": 1496,
                                 "optionName": "سرویس درب منزل",
                                 "description": "استفاده از سرویس رایگان",
                                 "optionInfoId": 1495,
                                 "priceInfoId": 1509,
                                 "imagesId": null,
                                 "priceInfoDtail": {
                                     "id": 1510,
                                     "title": "صث",
                                     "capacityRatio": null,
                                     "price": 200000,
                                     "coworkerPrice": null,
                                     "priceInfoId": 1509,
                                     "priceInfo": {
                                         "id": 1509,
                                         "fromValidDate": "2016-12-20T20:30:00.000Z",
                                         "priceType": "FIXED",
                                         "servants": []
                                     },
                                     "discount": null,
                                     "priceWithDiscount": 20000
                                 },
                                 "selected": true,
                                 "optionInfo": {
                                     "id": 1495,
                                     "title": "ServiceOption"
                                 }
                             }
                         ],

                         "participantPersons": [
                             {
                                 "id":null,
                                 "personInfoId":null,
                                 "orderBagItemDtailId":null,
                                 "personInfo":{
                                     "id":null,
                                     "nationalCode":'0080338291',
                                     "fisrtName":'sara',
                                     "lastName":'rezaie',
                                     "gender":null,
                                     "phoneNumber":"091291291256"
                                 }
                             }
                         ],
                         "timeSession": {
                             "id": 1646,
                             "startTime": "2016-11-07T14:40:00.000Z",
                             "endTime": "2016-11-07T15:10:00.000Z",
                             "startDate": "2016-11-07",
                             "endDate": "2016-11-07",
                             "capacity": 55,
                             "comment": " آماده",
                             "price": 50000,
                             "discount": 10,
                             "serviceTimeSessionInfoId": 1637,
                             "sessionTimesId": null
                         }
                     }*/


                ]
            };

            vm.orderBagVM = TestServices.saveOrderBagVM().save(vm.orderBagVM, onSaveSuccess, onSaveError);

        }


        function onSaveSuccess(result) {

            vm.orderBagVM = result;
            vm.isSaving = false;
        }

        function onSaveError() {

            vm.isSaving = false;
        }

        function testReminder() {
            TestServices.testReminder().query();
        }

        function getImageDataVMByAlbumId() {
            vm.imageList = TestServices.getImageDataVMByAlbumId('3825').query();
        }

        function sendTestSMS() {
            TestServices.sendTestSMS(vm.companyKeyUrl, vm.phoneNumber).query();
        }

        function sendVerificationTestSMS() {
            TestServices.sendVerificationTestSMS(vm.companyKeyUrl, vm.phoneNumber).query();
        }

        function sendTestEmail() {
            TestServices.sendTestEmail().query();
        }

        function finalApproveOrderBagById() {
            TestServices.finalApproveOrderBagById('7601').query();
        }

        function testSubscriptionNearToExpire() {
            TestServices.testSubscriptionNearToExpire().query();
        }

        function testUpdateExpireCompanyStatus() {
            TestServices.testUpdateExpireCompanyStatus().query();
        }

        function insertNewConversation() {

            var conversationVM = {};
            conversationVM.id = null;
            conversationVM.companyId = 1003;
            conversationVM.subject = 'test 1'


            vm.conversation = TestServices.insertNewConversation().save(conversationVM, onNewConvSuccess, onNewConvError);

        }

        function onNewConvSuccess(result) {
            vm.conversation = result;
        }

        function onNewConvError() {

        }

        function insertNewMessage() {

            var messageVM = {};
            messageVM.id = null;
            messageVM.conversationId = 1484400;
            messageVM.content = 'new message'

            vm.conversation = TestServices.insertNewMessage().save(messageVM, onNewMsgSuccess, onNewConvError);
        }

        function onNewMsgSuccess(result) {
            vm.message = result;
        }

        function cancelAllExpireTwoStepReserve() {
            TestServices.cancelAllExpireTwoStepReserve().query();
        }

        function getServiceAvailableDatesInNextDays() {
            var serviceItemid = prompt("Enter ServiceId", "0");
            var nextDays = prompt('Enter number of next days', "7");
            TestServices.getServiceAvailableDatesInNextDays(serviceItemid, nextDays).query(function (result) {
                vm.result = result;
            }, function (res) {
                vm.message = res;
            });
        }

        function getServiceAvailableTimesInOneDate() {
            var serviceItemid = prompt("Enter ServiceId", "0");
            var date = prompt('date', "1397/03/15");
            var fromHour = prompt('from Hour', "8");
            var toHour = prompt('to Hour', "20");
            TestServices.getServiceAvailableTimesInOneDate(serviceItemid, date, fromHour, toHour).query(function (result) {
                vm.result = result;
            }, function (res) {
                vm.message = res;
            });
        }

        function getCustomerByMobileNumber() {
            var mobileNumber = prompt('Enter customer mobile number', '09123470060');
            TestServices.getCustomerByMobileNumber(mobileNumber).query(function (result) {
                vm.result = result;
            }, function (res) {
                vm.message = res;
            });
        }

        function addTaminBranch() {
            var branchtitle = prompt('Enter branch title', 'شعبه');
            var branchurl = prompt('Enter bra nch url', 'tamin');
            var user = prompt('Enter user', 'acc');
            var baseurl = prompt('Enter base company url', 'tamin');
            TestServices.addTaminBranch(branchtitle, branchurl, user, baseurl).save(function (result) {
                vm.result = result;
                alert("DONE");
            }, function (res) {
                vm.message = res;
                alert("FAILED");
            });
        }

        function addmultiplebranch() {
            var branches = JSON.parse(vm.branchlist).list;
            angular.forEach(branches, function (br) {
                var yes = confirm(br.branchtitle + '/' + br.branchurl + '/' + br.user + '/' + br.baseurl);
                if (yes) {
                    TestServices.addTaminBranch(br.branchtitle, br.branchurl, br.user, br.baseurl).save(function (result) {
                        vm.result = result;
                        alert("DONE");
                    }, function (res) {
                        vm.message = res;
                        alert("FAILED");
                    });
                }
            })


        }

        function saveLocation(comapnyId, tel, address, mapX, mapY) {
            var location = {
                address: address,
                mapX: mapX,
                mapY: mapY
            }
            TestServices.addLocation(comapnyId, tel).save(location, function (data) {

            })
        }

        function addLocationList() {
            var locations = JSON.parse(vm.locationlist);
            var tocontinue = true;
            var row = 0;
            angular.forEach(locations, function (l) {
                row++;


                TestServices.findcompanyByKeyUrl(l.url).get(function (company) {
                    if (company && company.id) {
                        saveLocation(company.id, l.phone, l.address, l.lat, l.lng);
                    } else {
                        console.log('url ' + l.url + ' is not valid');
                    }

                });

            })
        }

        function sendTestCustomerSatisfactionSMS() {

            if (vm.orderBagId != null)
                TestServices.sendTestCustomerSatisfactionSMS(vm.orderBagId).query();
            else {
                alert("OrderBagId is Null !");
            }
        }

        function sendAllSatisfactionNotification() {

            TestServices.sendAllSatisfactionNotification().query();
        }


        function addDaysToSubscriptionByCompany() {
            if (vm.companyKeyUrl != "" && vm.daysToAdd > 0)
                TestServices.addDaysToSubscriptionByCompany(vm.companyKeyUrl, vm.daysToAdd).query();
        }


        function addFreeSMSPackage() {
            if (vm.smsPckCompanyUrl)
                TestServices.addFreeSMSPackage(vm.smsPckCompanyUrl, vm.smsPckStartDate).query(function (re) {
                    alert('free sms package added successfully');
                }, function (er) {
                    alert('error on adding sms package');
                    console.log(er);

                });
        }

        function addCustomSMSPackage() {
            if (vm.smsPckCompanyUrl)
                TestServices.addCustomSMSPackage(vm.smsPckCompanyUrl, vm.selectedSMSPackage, vm.smsPckStartDate).query(function (re) {
                    alert('free sms package added successfully');
                }, function (er) {
                    alert('error on adding sms package');
                    console.log(er);

                });
        }

        function getCompaniesSubscriptionNearToExpire() {
            var data = [];
            TestServices.getCompaniesSubscriptionNearToExpire().query().$promise.then(function (data) {
                vm.companies = data;
                var company = "";
                angular.forEach(vm.companies, function (item) {
                    company += ' || ' + item.title + ' - ' + item.keyUrl;
                });
                if (company.length > 0)
                    window.confirm(company);
                else
                    window.confirm("No Result Found !!");
            });

        }

        function sendTestCustomerFirstReminderSMS() {

            if (vm.orderBagId != null)
                TestServices.sendTestCustomerFirstReminderSMS(vm.orderBagId).query();
            else {
                alert("OrderBagId is Null !");
            }
        }

        function sendRebookNotification() {
            TestServices.sendRebookNotification().query();
        }

        function sendRebookSMS() {
            if (vm.orderBagId)
                TestServices.sendRebookSMS(vm.orderBagId).query();
        }


        function getTopNCompanyManager() {
            if (vm.recordCount)
                vm.companyManagers = TestServices.getTopNCompanyManager(vm.recordCount).query();
            else {
                alert(" is Null !");
            }
        }

        function getServantByMarketPlaceFilter() {
            var filter = {};
            filter.marketPlaceId = 1;
            // filter.tag = 'همایش';
            // filter.searchText = null;
            // filter.locationText = null;

            TestServices.getServantByMarketPlaceFilter().query(filter, function (result) {
                vm.marketPlaceServants = result;
            });

        }

        function addDaysToSubscriptionByCompaniesCategory() {

            if (vm.category != "" && vm.daysToAdd > 0)
                TestServices.addDaysToSubscriptionByCompaniesCategory(vm.category, vm.daysToAdd).query();
        }

        function setFeatureByCompanySubscriptionId() {
            if (vm.companySubsID != "")
                TestServices.setFeatureByCompanySubscriptionId(vm.companySubsID).query();
        }

        function sendTestReservationConfirmedInfoMsg() {

            if (vm.orderBagId != null)
                TestServices.sendTestReservationConfirmedInfoMsg(vm.orderBagId).query();
            else {
                alert("OrderBagId is Null !");
            }
        }

        function getToken() {

            var loginVm = {};
            loginVm.username = 'm.mansori';
            loginVm.password = '123456';
            loginVm.rememberMe = true;

            TestServices.getToken().save(loginVm, function (result) {

                console.log(result);

            }, function (result) {


                console.log("ERROR!")
            });

        }


        function createUserAccessForServantByPhoneNumber() {

            if (vm.servantPhoneNumber) {
                TestServices.createUserAccessForServantByPhoneNumber().save(vm.servantPhoneNumber, function (result) {
                    alert(result.status);
                }, function (result) {

                    alert(result.status);
                });

            }
        }

        function getReserveListByCustomer() {
            var mobileNumber = prompt('Enter customer mobile number', '09123470060');
            TestServices.getReserveListByCustomer(mobileNumber).query(function (result) {
                vm.result = result;
            }, function (res) {
                vm.message = res;
            });
        }

        function addBatchCompanyCustomer() {
        debugger;
            if (vm.batchCompanyCustomer) {
                var customers = JSON.parse(vm.batchCompanyCustomer);
                var newCompanyCustomer = [];

                angular.forEach(customers, function (customer) {

                    if (customer.fullName) {
                        var fullName = customer.fullName.trim();
                        customer.firstName = fullName.substring(0, fullName.indexOf(" ")).trim();
                        customer.lastName = fullName.substring(fullName.indexOf(" "), fullName.length).trim();

                    }

                    if (!customer.phoneNumber || !customer.firstName) {

                    } else {
                        var companyCustomer = {};
                        companyCustomer.customer = {};
                        companyCustomer.customer.personalInfo = {};

                        if (customer.phoneNumber.length == 10)
                            customer.phoneNumber = '0' + customer.phoneNumber;

                        companyCustomer.customer.personalInfo.fisrtName = customer.firstName;
                        companyCustomer.customer.personalInfo.phoneNumber = customer.phoneNumber;
                        if (customer.lastName)
                            companyCustomer.customer.personalInfo.lastName = customer.lastName;
                        if (customer.email)
                            companyCustomer.customer.personalInfo.email = customer.email;
                        if (customer.nationalCode)
                            companyCustomer.customer.personalInfo.nationalCode = customer.nationalCode;
                        if (customer.gender) {
                            if (customer.gender == 'MALE')
                                companyCustomer.customer.personalInfo.gender = true;
                            if (customer.gender == 'FEMALE')
                                companyCustomer.customer.personalInfo.gender = false;
                        }

                        if (customer.address) {
                            companyCustomer.customer.personalInfo.location = {};
                            companyCustomer.customer.personalInfo.location.address = customer.address;
                        }
//                        if(customer.birthDate) {
//                            companyCustomer.customer.personalInfo.birthDate = customer.birthDate;
//                        }
//
                        if (customer.birthDate) {
                            var dateParts = customer.birthDate.trim().split('/');

                            if (dateParts.length === 3) {
                                var gregorianDate = jalaliToGregorian(
                                    parseInt(dateParts[0], 10),
                                    parseInt(dateParts[1], 10),
                                    parseInt(dateParts[2], 10)
                                );

                                companyCustomer.customer.personalInfo.birthDate = moment({
                                    year: gregorianDate.year,
                                    month: gregorianDate.month - 1,
                                    day: gregorianDate.day,
                                    hour: 0,
                                    minute: 0,
                                    second: 0,
                                    millisecond: 0
                                }).format('YYYY-MM-DDTHH:mm:ssZ');
                            }
                        }

                        // intake fileds
                        var keyNames = Object.keys(customer);
                        var intakeFieldData = {};
                        var intakeFieldList = [];
                        angular.forEach(keyNames, function (key) {
                            if (key.includes("intake_")) {
                                var fieldName = key.replace("intake_", "");
                                var fieldValue = customer[key];
                                if (fieldValue) {
                                    var field = {};
                                    field.name = fieldName;
                                    field.value = fieldValue;
                                    field.label = null;
                                    field.field = null;

                                    intakeFieldList.push(field);
                                }
                            }
                        });

                        if (intakeFieldList && intakeFieldList.length > 0) {
                            intakeFieldData.fields = intakeFieldList;
                            companyCustomer.customerIntakeData = intakeFieldData;
                        }

                        //....................................................
                        newCompanyCustomer.push(companyCustomer);

                    }
                });

                if (newCompanyCustomer && newCompanyCustomer.length > 0) {
                    TestServices.addBatchCustomer().save(newCompanyCustomer, function (result) {
                        alert("done!");
                    }, function (result) {

                        alert("failed");
                    });
                }

            }
        }

        function testIcal() {
            TestServices.testIcalCalendat().query(function (result) {
                alert(result);
            }, function (res) {
                alert('error');
            });

        }

        function addSampleGtag() {

            //user Free Account Started
            try {
                //

                // gtag('event', 'freemium_start', {
                //     "items": [
                //         {
                //             "id": "PL102",
                //             "name": "14 Days Free Account",
                //             "list_name": "",
                //             "brand": "Planovin",
                //             "category": "CONSULT",
                //             "price": '0'
                //         }
                //     ]
                // });


                gtag('event', 'purchase_success', {
                    "transaction_id": 333334,
                    "value": 44000,
                    "currency": "USD",
                    "tax": 0,
                    "shipping": 0,
                    "items": [
                        {
                            "id": "PL104",
                            "name": "Package Base Test",
                            "list_name": "",
                            "brand": "Planovin",
                            "category": "category_test",
                            "quantity": 1,
                            "price": 44000
                        }

                    ]
                });

            } catch (err) {
                console.log(err);
            }
        }

        function sendTestCustomerSecondReminderSMS() {

            if (vm.orderBagId != null)
                TestServices.sendTestCustomerSecondReminderSMS(vm.orderBagId).query();
            else {
                alert("OrderBagId is Null !");
            }
        }

        function sendTestSMSPackageGoingToFinish() {

            if (vm.companyKeyUrl != null)
                TestServices.sendTestSMSPackageGoingToFinish(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestSMSPackageFinished() {

            if (vm.companyKeyUrl != null)
                TestServices.sendTestSMSPackageFinished(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestSubscriptionNearToExpireNotification() {

            if (vm.companyKeyUrl != null)
                TestServices.sendTestSubscriptionNearToExpireNotification(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestSubscriptionIsExpiredNotification() {

            if (vm.companyKeyUrl != null)
                TestServices.sendTestSubscriptionIsExpiredNotification(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestAutomaticSubscriptionNearToExpireNotification() {

            TestServices.sendTestAutomaticSubscriptionNearToExpireNotification().query();

        }

        function sendTestAutomaticApproveReserveRequest() {

            TestServices.sendTestAutomaticApproveReserveRequest().query();

        }

        function deActiveCompany() {
            if (vm.companyKeyUrl != null)
                CompanyCustom.deActiveCompanyByKeyURL(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestSupplierFirstJourneyNotification() {
            if (vm.phoneNumber)
                TestServices.sendTestSupplierFirstJourneyNotification(vm.phoneNumber).query(function (result) {
                    alert("DONE!")
                }, function (res) {
                    alert("Failed!")
                });
            else
                alert("phoneNumber is Null !");
        }


        function invoiceReport() {

            $window.open(TestServices.getInvoiceReportPdfUrl(26910632), '_blank');

        }


        function addBatchInvoiceInfo() {

            if (vm.batchInvoiceInfo) {
                var invoiceInfos = JSON.parse(vm.batchInvoiceInfo);
                var newInvoiceInfo = [];

                var iterator = 0;

                angular.forEach(invoiceInfos, function (invoiceInfo) {

                    if (!invoiceInfo.phoneNumber || !invoiceInfo.fullName) {

                    } else {
                        var companyCustomer = {};
                        companyCustomer.personalInfo = {};

                        if (invoiceInfo.phoneNumber.length == 10)
                            invoiceInfo.phoneNumber = '0' + invoiceInfo.phoneNumber;


                        invoiceInfo.fullName = invoiceInfo.fullName.trim();
                        companyCustomer.personalInfo.fisrtName = invoiceInfo.fullName.substring(0, invoiceInfo.fullName.indexOf(" ")).trim();
                        companyCustomer.personalInfo.lastName = invoiceInfo.fullName.substring(invoiceInfo.fullName.indexOf(" "), invoiceInfo.fullName.length).trim();

                        companyCustomer.personalInfo.phoneNumber = invoiceInfo.phoneNumber;

                        //.........................................
                        //add items
                        var existInvoice = newInvoiceInfo.filter(function (newItem) {
                            if (newItem.invoiceNo == invoiceInfo.invoiceNo)
                                return true;
                        });


                        if (existInvoice && existInvoice.length > 0) {
                            var item = {};
                            item.title = invoiceInfo.itemTitle;
                            item.type = "SERVICE";
                            item.price = 0;
                            item.qty = 1;
                            item.discount = 0;
                            if (invoiceInfo.serviceItemId)
                                item.referencedItemId = invoiceInfo.serviceItemId;
                            item.status = "DONE";


                            angular.forEach(newInvoiceInfo, function (info) {
                                if (info.invoiceNo == invoiceInfo.invoiceNo)
                                    info.invoiceInfoItems.push(item);
                            })

                        } else {

                            if (iterator >= 155) {
                                var x = 0;
                            }
                            var newInvoice = {};
                            newInvoice.customer = companyCustomer;
                            iterator++;
                            console.log(iterator);
                            console.log(companyCustomer);


                            var discount = 0;
                            var finalPrice = parseInt(invoiceInfo.finalPrice);

                            if (invoiceInfo.discount)
                                discount = parseInt(invoiceInfo.discount);

                            if (!invoiceInfo.totalServicePrice)
                                newInvoice.totalServicePrice = finalPrice + discount;

                            newInvoice.totalProductPrice = 0;
                            newInvoice.totalOptionPrice = 0;
                            newInvoice.totalVAT = 0;
                            newInvoice.totalDiscount = discount;
                            newInvoice.finalPrice = finalPrice;
                            newInvoice.comment = invoiceInfo.comment;
                            newInvoice.invoiceNo = invoiceInfo.invoiceNo;

                            //set invoice date

                            var dateTimeStr = invoiceInfo.invoiceDateTimeStr.split(" ");


                            var dateStr = toEnglishNumber(dateTimeStr[0]);
                            var dateSplit = dateStr.split('/');

                            var y = Number(dateSplit[0]);
                            var m = Number(dateSplit[1]);
                            var d = Number(dateSplit[2]);

                            var date = jalaali.jalaaliToDateObject(y, m, d);


                            var invoiceTime = dateTimeStr[1];
                            var split = invoiceTime.split(':');
                            date.setHours(split[0], split[1], 0);

                            newInvoice.invoiceDate = date;


                            var item = {};
                            item.title = invoiceInfo.itemTitle;
                            item.type = "SERVICE";
                            item.price = finalPrice + discount;
                            item.qty = 1;
                            item.discount = 0;
                            if (invoiceInfo.serviceItemId)
                                item.referencedItemId = invoiceInfo.serviceItemId;
                            item.status = "DONE";

                            newInvoice.invoiceInfoItems = [];

                            newInvoice.invoiceInfoItems.push(item);

                            newInvoiceInfo.push(newInvoice);
                        }

                        //....................................................

                    }
                });

                if (newInvoiceInfo && newInvoiceInfo.length > 0) {
                    TestServices.addBatchInvoiceInfo().save(newInvoiceInfo, function (result) {
                        alert("done!");
                    }, function (result) {

                        alert("failed");
                    });
                }

            }
        }


        function toEnglishNumber(str) {
            var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
                arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

            if (typeof str === 'string') {
                for (var i = 0; i < 10; i++) {
                    str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
                }
            }
            return str;
        }

        function sendAutomaticMarketingCampaign() {
            TestServices.sendAutomaticMarketingCampaign().query();
        }

        function testCalculateCommission() {
            TestServices.testCalculateCommission().query();
        }

        function testTehranTime() {

            var jun = moment();
            var xx = jun.tz('Asia/Tehran').format('');  // 5am PDT
            return xx;
        }

        function testSmsNearFinish() {
            TestServices.testSmsNearFinish().query();
        }

        function sendMarketingCampaign() {
            if(vm.sendMarketingCampaignLoading || !vm.marketingCampaignId) return
            vm.sendMarketingCampaignLoading = true;

            TestServices
                .testSendMarketingCampaign()
                .send(
                    {
                        marketingCampaignId: vm.marketingCampaignId
                    },
                    onMarketingSaveSuccess,
                    onMarketingSaveError
                );

           function onMarketingSaveSuccess(result) {
               vm.sendMarketingCampaignLoading = false;
               alert(result.message);
           }

           function onMarketingSaveError(response) {
               vm.sendMarketingCampaignLoading = false;
               alert(response.data.message);
           }
        }


        function jalaliToGregorian(jy, jm, jd) {
            jy += 1595;

            var days =
                -355668 +
                (365 * jy) +
                (Math.floor(jy / 33) * 8) +
                Math.floor(((jy % 33) + 3) / 4) +
                jd +
                (jm < 7
                    ? (jm - 1) * 31
                    : ((jm - 7) * 30) + 186);

            var gy = 400 * Math.floor(days / 146097);
            days %= 146097;

            if (days > 36524) {
                gy += 100 * Math.floor(--days / 36524);
                days %= 36524;

                if (days >= 365) {
                    days++;
                }
            }

            gy += 4 * Math.floor(days / 1461);
            days %= 1461;

            if (days > 365) {
                gy += Math.floor((days - 1) / 365);
                days = (days - 1) % 365;
            }

            var gd = days + 1;
            var monthDays = [
                0,
                31,
                ((gy % 4 === 0 && gy % 100 !== 0) || gy % 400 === 0) ? 29 : 28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ];

            var gm = 1;

            while (gm <= 12 && gd > monthDays[gm]) {
                gd -= monthDays[gm];
                gm++;
            }

            return {
                year: gy,
                month: gm,
                day: gd
            };
        }

        function mergeCompanyCustomers() {
            debugger;

            if (!vm.companyCustomerIds) {
                return;
            }

            var customerIds = vm.companyCustomerIds
                .split(',')
                .map(function (id) {
                    return parseInt(id.trim(), 10);
                })
                .filter(function (id) {
                    return !isNaN(id);
                });

            if (customerIds.length === 0) {
                return;
            }

            CompanyCustomerCustom
                .mergeCompanyCustomers()
                .merge(
                    customerIds,
                    onMergeSaveSuccess,
                    onMergeSaveError
                );

            function onMergeSaveSuccess(result) {
                // alert(result.message);
                alert('success');
            }

            function onMergeSaveError(response) {
                alert(response.data.failureReason);
            }
        }

        function removePhoneNumber() {
            if(vm.removePhoneNumberLoading) return
            vm.removePhoneNumberLoading = true;
            TestServices.removePhoneNumber().delete({phoneNumber: vm.phoneNumber},
                function(res){
                    alert('User deleted Successfully');
                    vm.removePhoneNumberLoading = false;
                }, function(err){
                    alert(err.data.message)
                    vm.removePhoneNumberLoading = false;
                })
        }
    }
})();
